import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Calculator } from './components/Calculator';
import { Markets } from './pages/Markets';
import { Exchanges } from './pages/Exchanges';
import { Facilities } from './pages/Facilities';
import { FacilityDetails } from './pages/FacilityDetails';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { UserSettings } from './components/settings/UserSettings';
import { UserDashboard } from './pages/UserDashboard';
import { Navbar } from './components/Navbar';
import { HomeHero } from './components/hero/HomeHero';
import { useExchangeRates } from './utils/currencyUtils';
import { AuthProvider } from './components/auth/AuthProvider';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { ResetPassword } from './components/auth/ResetPassword';
import { Toaster } from 'react-hot-toast';
import { MinerDetails } from './pages/MinerDetails';
import { Resources } from './pages/Resources';
import { Footer } from './components/Footer';
import { Loader } from './components/common/Loader';
import { PriceOverlay } from './components/PriceOverlay';
import { Bitcoin } from 'lucide-react';

export default function App() {
  const [currency, setCurrency] = useState('USD');
  const [powerCost, setPowerCost] = useState(0.1);
  const { rates: exchangeRates, isLoading: ratesLoading } = useExchangeRates();
  const [isPriceOverlayOpen, setIsPriceOverlayOpen] = useState(false);

  if (ratesLoading) {
    return <Loader />;
  }

  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Navbar 
            currency={currency}
            powerCost={powerCost}
            onCurrencyChange={setCurrency}
            onPowerCostChange={setPowerCost}
          />
          <div className="flex-grow pt-16">
            <Routes>
              <Route 
                path="/miner/:id" 
                element={
                  <MinerDetails
                    currency={currency}
                    exchangeRates={exchangeRates}
                    powerCost={powerCost}
                  />
                }
              />
              <Route 
                path="/" 
                element={
                  <>
                    <HomeHero />
                    <Calculator 
                      currency={currency} 
                      exchangeRates={exchangeRates}
                      powerCost={powerCost}
                      onPowerCostChange={setPowerCost}
                      onCurrencyChange={setCurrency}
                    />
                  </>
                } 
              />
              <Route 
                path="/markets" 
                element={
                  <Markets 
                    currency={currency} 
                    exchangeRates={exchangeRates} 
                  />
                } 
              />
              <Route path="/exchanges" element={<Exchanges />} />
              <Route path="/facilities" element={<Facilities />} />
              <Route path="/facilities/:id" element={<FacilityDetails />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <UserDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <UserSettings />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
          <Footer />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 2000,
              style: {
                opacity: 0.9,
                backgroundColor: '#363636',
                color: '#fff',
              }
            }}
          />
          
          {/* BTC Price Overlay Toggle Button */}
          <button
            onClick={() => setIsPriceOverlayOpen(prev => !prev)}
            className="fixed bottom-4 right-4 p-3 bg-white rounded-full shadow-lg hover:shadow-xl transition-shadow border border-gray-200 z-40"
          >
            <Bitcoin className="w-6 h-6 text-orange-500" />
          </button>

          {/* BTC Price Overlay */}
          <PriceOverlay 
            isOpen={isPriceOverlayOpen}
            onClose={() => setIsPriceOverlayOpen(false)}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}